import type { IsoDate } from './monthGrid';

const pad = (n: number): string => String(n).padStart(2, '0');

/** Today's local date as `YYYY-MM-DD`, read on every call so a screen left open overnight catches up. */
export const useToday = (): IsoDate => {
  const now = new Date();
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};
